import {AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, ViewChild} from "@angular/core";
import {WatchService} from "../../services/watch.service";
import {IDocument} from "../../interfaces/document.definition";
import * as _ from "underscore";
import {localeUtils} from "../../helpers/locale-utils";
import {_document} from "@angular/platform-browser/src/browser";
import {IEnumListEntry} from "../../definitions";
declare const $: any;


@Component({
  selector: "nv-select2",
  templateUrl: "./nv-select2.component.html"
})


export class NvSelect2Component implements AfterViewInit {
  @ViewChild("selectElem") elementRef: ElementRef;

  @Input() set document(val:any) {
    //console.log(val);
    this._document= val;
    this.updateOptions();
  }

  get document() {
    //console.log(this._document);
    return this._document;
  }

  @Input() prop: string;
  @Output() itemSelected = new EventEmitter();
  @Input() set options(val:IDocument[])  {
    this.setItems(val);
  }

  private items: IDocument[] = [];
  private disabledIds: number[] = [];
  private _document:any;

  constructor(private watchService: WatchService) {
  }


  ngAfterViewInit(): void {
    $(this.elementRef.nativeElement)
      .select2()
      .on("select2:select", (event: any) => {
        console.log(event);
        this.onSelected(+$(event.target).val());
    });
  }


  setItems(items: IDocument[]): void {
    //console.log(items);
    if (this.items === items) {
      return;
    }

    this.items = items;
    this.updateOptions();
  }


  setDisabledItemIds(disabledIds: number[]): void {
    this.disabledIds = disabledIds;
    this.updateDisableStateForOptions();
  }


  onSelected(id: number) {
    console.log(id);
    this._document[this.prop] = id;
    this.watchService.notify();
    this.itemSelected.emit();
  }


  private updateOptions() {
    // todo: find 'name' is too slow! must be improved

    let data = this.items.map(
      d => {
        let name = localeUtils.findName(d);
        return {
          id: d.id,
          text: `${name} (${d.id})`
        };
      });
    let selectedId = this.document[this.prop];

    $(this.elementRef.nativeElement)
      .select2({data: data})
      .val(selectedId)
      .trigger("change");
  }


  private updateDisableStateForOptions() {
    $(this.elementRef.nativeElement)
      .find("option")
      .each((i,
             o) => {
        if (this.disabledIds.indexOf(+$(o).attr("value")) >= 0) {
          $(o).attr("disabled", "disabled");
        } else {
          $(o).removeAttr("disabled", "disabled");
        }
      });

    $(this.elementRef.nativeElement)
      .select2()
      .trigger("change");
  }
}



// WEBPACK FOOTER //
// /opt/app/develop/src/app/components/nv-select/nv-select2.component.ts